import { render, staticRenderFns } from "./VideosGalleryList.vue?vue&type=template&id=1a136cf5&"
import script from "./VideosGalleryList.vue?vue&type=script&lang=js&"
export * from "./VideosGalleryList.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports